import { render } from "./DataPicMonitoring.vue?vue&type=template&id=245f5164"
import script from "./DataPicMonitoring.vue?vue&type=script&lang=js"
export * from "./DataPicMonitoring.vue?vue&type=script&lang=js"

import "./DataPicMonitoring.vue?vue&type=style&index=0&id=245f5164&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__